<template>
    <div :class="formGroupClass">
        <label v-if="displayLabel && getShowRouteName() == null || getShowId() == null" class="control-label col-md-3">{{ title }}</label>
        <label v-else-if="displayLabel" class="control-label col-md-3"><a :href="generateRoute()" target="_blank">
          {{ title }} <i class="fa fa-link"></i></a>
        </label>
        <div  :class="columnClass">
            <vue-multiselect
                    :id="id"
                    v-model="value"
                    :options="options"
                    :searchable="true"
                    :allow-empty="allowEmpty"
                    :label="labelName"
                    :track-by="trackByName"
                    placeholder=""
                    :select-label="labelSelect"
                    :deselect-label="labelDeselect"
                    :selected-label="labelSelected"
                    :disabled="disabled"
                    :show-labels="showLabels"
                    :custom-label="customLabel"
                    :options-limit="optionsLimit"
                    @select="$emit('dispatch', $event)"
                    @search-change="$emit('search', $event)"
            >
                <span slot="noResult">Brak wyników. Spróbuj zmienić wpisywaną frazę.</span>
            </vue-multiselect>

            <span v-if="errorText" class="help-block">
                <p> {{errorText}} </p>
            </span>
        </div>

        <div v-if="button" class="col-md-2">
            <div class="form-group">
                <button class="btn btn-success" type="button" @click="$emit('buttondispatch')">{{ buttonLabel }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import mixins from '@js/mixins'

export default {
  components: {
    VueMultiselect
  },
  mixins: [mixins],
  props: {
    customLabel: {
      type: Function,
      default: undefined
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
    options: {
      type: [Array, String],
      default: () => []
    },
    label: {
      type: String,
      default: 'name'
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showRouteName: {
      type: String,
      default: null
    },
    optionsLimit: {
      type: Number,
      default: 9999
    },
    showIdParamName: {
      type: String,
      default: 'id'
    },
    showAdditionalParams: {
      type: Object,
      default: () => {}
    },
    checked: {
      type: [Object, String, Number, Boolean],
      default: null
    },
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    buttonLabel: {
      type: String,
      default: ''
    },
    errors: {
      type: Object,
      default: () => {},
    },
    onlyLabel: {
      type: Boolean,
      default: false
    },
    button: {
      type: [Boolean, String, Number],
      default: false
    },
  },
  data: function () {
    return {
      value: null,
      labelName : this.showLabels ? this.label : undefined,
      trackByName : this.showLabels ? this.trackBy : undefined,
      id : `form_${this.name}`,
      errorText: false,
      formGroupClass: 'form-group',
      labelSelect: Translator.trans('multiselect.select'),
      labelDeselect: this.allowEmpty ? Translator.trans('multiselect.remove') : '',
      labelSelected: Translator.trans('multiselect.selected'),
    }
  },
  computed: {
    columnClass: function() {
      let colNumber = this.displayLabel ? 9 : 10
      return `col-md-${this.button ? colNumber - 2 : colNumber}`
    }
  },
  watch : {
    errors(value) {
      if (value && this.name) {
        const error = this.getNestedObjectValue(value, this.name)

        if (error) {
          this.errorText = Object.values(error).join()
          this.formGroupClass = 'form-group has-error'
          return
        }
      }

      this.errorText = false
      this.formGroupClass = 'form-group'
    },
    value:  {
      handler(value) {
        let emit = null
        if (this.showLabels) {
          emit = value ? value[this.trackBy] : null
        } else {
          emit = value
        }
        this.$emit('input', emit)
      },
      deep: true
    },
    checked:  {
      handler() {
        this.value = this.prepareValue()
      },
      deep: true
    },
    options: function() {
      if (this.onlyLabel) {
        for (let ind in this.options) {
          if (typeof this.options[ind] === 'object') {
            // eslint-disable-next-line vue/no-mutating-props
            this.options[ind] = this.options[ind][this.label]
          }
        }
      }

      this.value = this.prepareValue()
    },
  },
  mounted() {
    this.value = this.prepareValue()
  },
  methods: {
    prepareValue() {
      if (!this.showLabels) {
        this.$emit('input', this.checked)
        return this.checked
      }

      let prepareValue = {}
      let checked = null

      if (this.checked && this.checked.id) {
        checked = !isNaN(parseInt(this.checked.id)) ? parseInt(this.checked.id) : this.checked
      } else {
        checked = !isNaN(parseInt(this.checked)) ? parseInt(this.checked) : this.checked
      }
      prepareValue[this.trackBy] = checked
      for (let i = 0; i < this.options.length ; i++) {
        if (this.options[i][this.trackBy] === checked) {
          prepareValue[this.label] = this.options[i][this.label]
        }
      }

      this.$emit('input', checked)
      return prepareValue
    },
    getShowRouteName() {
      if (this.showRouteName !== null) {
        if (this.showRouteName === false) {
          return null
        }
        return this.showRouteName
      }

      try {
        let params = {}
        params[this.showIdParamName] = this.getShowId()
        Routing.generate(`${this.name}_show`, Object.assign(params, this.showAdditionalParams))
      } catch (err) {
        return null
      }

      return `${this.name}_show`
    },
    generateRoute() {
      let params = {}
      params[this.showIdParamName] = this.getShowId()
      return Routing.generate(this.getShowRouteName(), Object.assign(params, this.showAdditionalParams))
    },
    getShowId() {
      if (!this.value) {
        return null
      }

      return this.value[this.trackByName]
    }
  },
}
</script>
